import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastService } from 'src/app/common/service/toast.service';
import { FormFieldElement } from '../../model/form-field-element';
import { validateAllFormFields } from '../../util/validation-util';
import { Option } from '../../../settings/model/value-field';

@Component({
  selector: 'app-form-editor',
  templateUrl: './form-editor.component.html',
  styleUrls: ['./form-editor.component.scss']
})
export class FormEditorComponent implements OnChanges {

  // TODO add MAC address select like in old panel

  @Input()
  addNewText: string = 'add';
  @Input()
  addModeText: string = 'addingNewRecord';
  @Input()
  editModeText: string = 'editingRecord';
  @Input()
  formFieldElements: FormFieldElement[];
  @Input()
  hideTopAddButton: boolean = false;
  @Input()
  allowCreateNew: boolean = true;
  @Input()
  showCancel: boolean = false;
  @Input()
  translateOptions: boolean = true;
  @Output()
  saveObject = new EventEmitter<any>();
  @Output()
  editNew = new EventEmitter<void>();
  @Output()
  cancelled = new EventEmitter<void>();

  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private toast: ToastService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formFieldElements && this.formFieldElements) {
      this.createForm();
    }
  }

  private createForm(): void {
    const form = this.formBuilder.group({});
    for (const field of this.formFieldElements) {
      const validators = field.validators?.map(validator => validator.validator) || [];
      form.addControl(field.name, new FormControl({ value: field.defaultValue || null, disabled: field.disabledOnNew }, validators));
    }
    this.form = form;
  }

  resetForm(): void {
    const values = this.formFieldElements.reduce((map, field) => {
      map[field.name] = field.defaultValue || null;
      return map;
    }, {});
    this.form.reset(values);
    this.formFieldElements.forEach(field => field.disabledOnNew ? this.form.get(field.name).disable() : this.form.get(field.name).enable());
  }

  updateFormField(fieldToUpdate: FormFieldElement): void {
    const idx = this.formFieldElements.findIndex(element => element.name == fieldToUpdate.name);
    if (idx >= 0)
      this.formFieldElements[idx] = fieldToUpdate;
    else
      this.formFieldElements.push(fieldToUpdate);
    this.createForm();
  }

  new(): void {
    this.editNew.emit();
    this.resetForm();
  }

  editObject(editableObject: any): void {
    this.form.patchValue(editableObject);
    this.formFieldElements.forEach(field => field.disabledOnEdit ? this.form.get(field.name).disable() : this.form.get(field.name).enable());
    if (editableObject?.locationName) {
      const field = this.formFieldElements.find(fld => fld.name === 'locationName');
      field.defaultValue = editableObject.locationName;
    }
  }

  save(): void {
    validateAllFormFields(this.form);
    if (this.form.valid) {
      this.saveObject.emit(this.form.getRawValue());
    } else {
      this.toast.showErrorToast('fillFormCorrectly');
    }
  }

  get showAddButton(): boolean {
    const pkField = this.formFieldElements.find(element => element.pk);
    if (pkField)
      return this.form.getRawValue()[pkField.name];
    else
      return true;
  }

  getOptionValues(options: Option[]): any[] {
    return options?.map(option => option.key);
  }

  isTextarea(field: any): boolean {
    return field?.formFieldType === 'area' || field?.formFieldType === 'resizing-area';
  }

  getMinRows(field: any): number {
    return field?.formFieldType === 'resizing-area' ? 1 : 4;
  }

  getMaxRows(): number {
    return 15;
  }

}
